import { c as _c } from "react/compiler-runtime";
import { BlogsIcon, ContactIcon, CourseIcon, FunnelIcon, StoreIcon, MoneyBillTransferIcon } from '@systemeio/ui/icons';
import { FormInput, Hint, centsToUnits } from '@systemeio/ui';
import { replaceWwwForHosts } from '@systemeio/util';
import { DetailsList } from 'modules/subaccounts/components/details-list';
import { subAccountDefaultCreateValues, subAccountDefaultErrors } from 'modules/subaccounts/constants/sub-account-default-values';
import { SubAccountsLoco } from 'modules/subaccounts/constants/sub-accounts-loco';
import { useSubAccounts } from 'modules/subaccounts/hooks/use-sub-accounts';
import { useSubAccountsActions } from 'modules/subaccounts/hooks/use-sub-accounts-actions';
import { SubAccountCreateInterface, SubAccountErrorsInterface, SubAccountInterface } from 'modules/subaccounts/types/sub-account-interface';
import { getSubAccountNewLeadsStatistics } from 'modules/subaccounts/utils/get-sub-account-new-leads-statistics';
import { findResourceByUserId } from 'modules/subaccounts/utils/get-sub-account-resources';
import { getSubAccountSalesStatistics } from 'modules/subaccounts/utils/get-sub-account-sales-statistics';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { generatePretendUserUrl } from 'shared/hooks/use-user/utils/generate-pretend-user-url';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { currencyFormat } from 'shared/utils/currency-format';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { getBaseServerSideProps, getCombinedServerSideProps } from 'shared/utils/get-base-server-side-props';
import { generatePathFromName } from 'shared/utils/path-utils';
import { isClient } from 'shared/components/screen-height-div';
import { hasSubAccounts } from 'shared/hooks/use-user/utils/has-subaccounts';
const iconProps = {
  width: 20,
  height: 20,
  className: 'fill-text-secondary'
};
function SubAccounts() {
  const $ = _c(119);
  const {
    t,
    tICU
  } = useLocoTranslation();
  const {
    user,
    mutate: mutateUser
  } = useUser();
  const router = useRouter();
  const {
    deleteSubAccount,
    createSubAccount,
    editSubAccount
  } = useSubAccountsActions();
  const [errors, setErrors] = useState(subAccountDefaultErrors);
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  let t0;
  if ($[0] !== limit || $[1] !== pagination) {
    t0 = {
      pagination,
      limit
    };
    $[0] = limit;
    $[1] = pagination;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    subAccounts,
    counter,
    mutate,
    resources,
    isLoadingResources,
    sales,
    isLoadingSales,
    newLeads,
    isLoadingNewLeads,
    revalidateSubAccountsModule
  } = useSubAccounts(t0);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setErrors(subAccountDefaultErrors);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onModalClose = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("global.name");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      key: "name",
      header: t2,
      onRender: _temp,
      widthPercent: 20
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.sub_accounts.resources");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isLoadingResources || $[11] !== resources?.items || $[12] !== t || $[13] !== user?.dateFormat || $[14] !== user?.timeFormat || $[15] !== user?.timezone) {
    t5 = subAccount_0 => {
      const data = findResourceByUserId(subAccount_0.user.id, resources?.items);
      if (isLoadingResources) {
        return <div className="bg-skeleton-primary rounded-xs animate-pulse py-2.5" />;
      }
      if (!data) {
        return null;
      }
      const resourcesList = [<><span>{t("global.created_on")}:</span><span className="truncate" title={dateTimeFormat(data.user.createdAt, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}>{dateTimeFormat(data.user.createdAt, {
            timeFormat: user?.timeFormat,
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          })}</span></>, <><ContactIcon {...iconProps} /><span>{data.contacts}</span>{t("dashboard.sub_accounts.contacts")}</>, <><FunnelIcon {...iconProps} /><span>{data.funnels}</span>{t("dashboard.sub_accounts.funnels")}</>, <><BlogsIcon {...iconProps} /><span>{data.blogs}</span>{t("dashboard.sub_accounts.blogs")}</>, <><CourseIcon {...iconProps} /><span>{data.courses}</span>{t("dashboard.sub_accounts.courses")}</>, <><StoreIcon {...iconProps} /><span>{data.digitalStores}</span>{t("dashboard.sub_accounts.digital_stores")}</>];
      return <DetailsList rows={resourcesList} />;
    };
    $[10] = isLoadingResources;
    $[11] = resources?.items;
    $[12] = t;
    $[13] = user?.dateFormat;
    $[14] = user?.timeFormat;
    $[15] = user?.timezone;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = {
      key: "resources",
      header: t4,
      onRender: t5,
      widthPercent: 20
    };
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t) {
    t7 = t("dashboard.sub_accounts.last_30_days");
    $[20] = t;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t) {
    t8 = t("dashboard.sub_accounts.statistics");
    $[22] = t;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <Hint label={t7}>{t8}</Hint>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== isLoadingNewLeads || $[28] !== isLoadingSales || $[29] !== newLeads?.items || $[30] !== sales?.items || $[31] !== t || $[32] !== user?.dashboardLocale) {
    t10 = subAccount_1 => {
      if (isLoadingSales || isLoadingNewLeads) {
        return <div className="bg-skeleton-primary rounded-xs animate-pulse py-2.5" />;
      }
      const statisticsList = [<><MoneyBillTransferIcon {...iconProps} /><div className="flex flex-col gap-1">{getSubAccountSalesStatistics(subAccount_1, sales?.items)?.sales.map(t11 => {
            const {
              currency,
              value
            } = t11;
            return <span key={currency}>{currencyFormat(centsToUnits(value), currency, user?.dashboardLocale)}</span>;
          })}</div>{t("dashboard.sub_accounts.sales")}</>, <><FunnelIcon {...iconProps} /><div className="flex flex-col gap-1">{getSubAccountNewLeadsStatistics(subAccount_1, newLeads?.items)?.newLeads}</div>{t("dashboard.sub_accounts.new_leads")}</>];
      return <DetailsList rows={statisticsList} />;
    };
    $[27] = isLoadingNewLeads;
    $[28] = isLoadingSales;
    $[29] = newLeads?.items;
    $[30] = sales?.items;
    $[31] = t;
    $[32] = user?.dashboardLocale;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t9) {
    t11 = {
      key: "statistics",
      header: t9,
      onRender: t10
    };
    $[34] = t10;
    $[35] = t9;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t11 || $[38] !== t3 || $[39] !== t6) {
    t12 = [t3, t6, t11];
    $[37] = t11;
    $[38] = t3;
    $[39] = t6;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  const columns = t12;
  let t13;
  if ($[41] !== createSubAccount || $[42] !== mutateUser || $[43] !== revalidateSubAccountsModule) {
    t13 = async subAccount_2 => {
      await fetchWithErrors(async () => {
        const newSubAccount = await createSubAccount(subAccount_2);
        revalidateSubAccountsModule(true);
        await mutateUser(data_0 => {
          if (!data_0) {
            return;
          }
          if (hasSubAccounts(data_0)) {
            return {
              ...data_0,
              subaccounts: [...data_0.subaccounts, newSubAccount]
            };
          } else {
            return {
              ...data_0,
              subaccounts: [newSubAccount]
            };
          }
        }, false);
      }, setErrors);
    };
    $[41] = createSubAccount;
    $[42] = mutateUser;
    $[43] = revalidateSubAccountsModule;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  const onCreate = t13;
  let t14;
  if ($[45] !== editSubAccount || $[46] !== mutate || $[47] !== mutateUser || $[48] !== revalidateSubAccountsModule) {
    t14 = async (oldData, updatedData) => {
      await fetchWithErrors(async () => {
        const returnedData = await editSubAccount(oldData.user.id, {
          name: updatedData.displayName
        });
        await mutate(data_1 => data_1 && {
          items: data_1.items.map(item => {
            if (item.id === oldData.id) {
              item = returnedData;
            }
            return item;
          }),
          hasMore: data_1.hasMore
        }, false);
        await mutateUser(data_2 => {
          if (!data_2 || !hasSubAccounts(data_2)) {
            return;
          }
          return {
            ...data_2,
            subaccounts: data_2.subaccounts.map(item_0 => {
              if (item_0.id === oldData.id) {
                return returnedData;
              }
              return item_0;
            })
          };
        }, false);
      }, setErrors);
      revalidateSubAccountsModule();
    };
    $[45] = editSubAccount;
    $[46] = mutate;
    $[47] = mutateUser;
    $[48] = revalidateSubAccountsModule;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  const onEdit = t14;
  let t15;
  if ($[50] !== deleteSubAccount || $[51] !== mutateUser || $[52] !== revalidateSubAccountsModule) {
    t15 = async subAccount_3 => {
      await deleteSubAccount(subAccount_3.user.id);
      revalidateSubAccountsModule(true);
      await mutateUser(data_3 => {
        if (!data_3 || !hasSubAccounts(data_3)) {
          return;
        }
        return {
          ...data_3,
          subaccounts: data_3.subaccounts.filter(item_1 => item_1.user.id !== subAccount_3.user.id)
        };
      }, false);
    };
    $[50] = deleteSubAccount;
    $[51] = mutateUser;
    $[52] = revalidateSubAccountsModule;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  const onRemove = t15;
  let t16;
  if ($[54] !== router) {
    t16 = subAccount_4 => {
      router.push(generatePretendUserUrl(subAccount_4.user.id));
    };
    $[54] = router;
    $[55] = t16;
  } else {
    t16 = $[55];
  }
  const onImpersonateSubAccount = t16;
  const t17 = counter?.count;
  let t18;
  if ($[56] !== t17 || $[57] !== tICU) {
    t18 = tICU("dashboard.sub_accounts.title_icu", {
      count: t17
    });
    $[56] = t17;
    $[57] = tICU;
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  let t19;
  if ($[59] !== t) {
    t19 = t("dashboard.sub_account.title");
    $[59] = t;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  const t20 = !subAccounts;
  let t21;
  if ($[61] !== t) {
    t21 = t("dashboard.sub_account.toast_create");
    $[61] = t;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["name", "domain"];
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== errors || $[65] !== t) {
    t23 = {
      field: "name",
      onRender: (value_0, onChange) => <FormInput required={true} key="sub-account-name-create" label={t("global.name")} value={value_0} onChange={e => onChange(e.target.value)} error={errors.name} />
    };
    $[64] = errors;
    $[65] = t;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  let t24;
  if ($[67] !== errors || $[68] !== t) {
    t24 = {
      field: "domain",
      onRender: (value_1, onChange_0, state) => <FormInput required={true} key="sub-account-domain-create" label={t("dashboard.sub_accounts.sub_domain")} error={errors.domain} addonBefore={`${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://`} addonAfter={isClient() ? `.${replaceWwwForHosts(window.location.host)}` : undefined} onChange={e_0 => onChange_0(e_0.target.value)} onFocus={e_1 => {
        if (!e_1.target.value) {
          onChange_0(generatePathFromName(state.name));
        }
      }} value={value_1} />
    };
    $[67] = errors;
    $[68] = t;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== t23 || $[71] !== t24) {
    t25 = [t23, t24];
    $[70] = t23;
    $[71] = t24;
    $[72] = t25;
  } else {
    t25 = $[72];
  }
  let t26;
  if ($[73] !== onCreate || $[74] !== t19 || $[75] !== t20 || $[76] !== t21 || $[77] !== t25) {
    t26 = {
      defaultValues: subAccountDefaultCreateValues,
      onCreate,
      caption: t19,
      disabled: t20,
      toastCaption: t21,
      requiredFields: t22,
      creatable: t25
    };
    $[73] = onCreate;
    $[74] = t19;
    $[75] = t20;
    $[76] = t21;
    $[77] = t25;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  let t27;
  if ($[79] !== t) {
    t27 = t("dashboard.sub_account.title");
    $[79] = t;
    $[80] = t27;
  } else {
    t27 = $[80];
  }
  let t28;
  if ($[81] !== onRemove) {
    t28 = {
      onChange: onRemove
    };
    $[81] = onRemove;
    $[82] = t28;
  } else {
    t28 = $[82];
  }
  let t29;
  if ($[83] !== errors || $[84] !== t) {
    t29 = [{
      field: "displayName",
      onRender: (value_2, onChange_1) => <FormInput required={true} key="sub-account-display-name-edit" label={t("global.name")} value={value_2} onChange={e_2 => onChange_1(e_2.target.value)} error={errors.name} />
    }];
    $[83] = errors;
    $[84] = t;
    $[85] = t29;
  } else {
    t29 = $[85];
  }
  let t30;
  if ($[86] !== onEdit || $[87] !== t29) {
    t30 = {
      onEdit,
      onModalClose,
      editable: t29
    };
    $[86] = onEdit;
    $[87] = t29;
    $[88] = t30;
  } else {
    t30 = $[88];
  }
  let t31;
  if ($[89] !== t) {
    t31 = t("dashboard.sub_account.impersonate");
    $[89] = t;
    $[90] = t31;
  } else {
    t31 = $[90];
  }
  let t32;
  if ($[91] !== onImpersonateSubAccount) {
    t32 = instance => onImpersonateSubAccount(instance);
    $[91] = onImpersonateSubAccount;
    $[92] = t32;
  } else {
    t32 = $[92];
  }
  let t33;
  if ($[93] !== t31 || $[94] !== t32) {
    t33 = [{
      caption: t31,
      name: "impersonateToSubAccount",
      onActionClick: t32
    }];
    $[93] = t31;
    $[94] = t32;
    $[95] = t33;
  } else {
    t33 = $[95];
  }
  let t34;
  if ($[96] !== t28 || $[97] !== t30 || $[98] !== t33) {
    t34 = {
      remove: t28,
      settings: t30,
      custom: t33
    };
    $[96] = t28;
    $[97] = t30;
    $[98] = t33;
    $[99] = t34;
  } else {
    t34 = $[99];
  }
  let t35;
  if ($[100] !== limit || $[101] !== setLimit) {
    t35 = {
      limit,
      setLimit
    };
    $[100] = limit;
    $[101] = setLimit;
    $[102] = t35;
  } else {
    t35 = $[102];
  }
  let t36;
  if ($[103] !== pagination || $[104] !== setPagination) {
    t36 = {
      pagination,
      setPagination
    };
    $[103] = pagination;
    $[104] = setPagination;
    $[105] = t36;
  } else {
    t36 = $[105];
  }
  let t37;
  if ($[106] !== columns || $[107] !== subAccounts || $[108] !== t27 || $[109] !== t34 || $[110] !== t35 || $[111] !== t36) {
    t37 = <Table columns={columns} caption={t27} data={subAccounts} actions={t34} limiter={t35} paginator={t36} />;
    $[106] = columns;
    $[107] = subAccounts;
    $[108] = t27;
    $[109] = t34;
    $[110] = t35;
    $[111] = t36;
    $[112] = t37;
  } else {
    t37 = $[112];
  }
  let t38;
  if ($[113] !== counter || $[114] !== subAccounts || $[115] !== t18 || $[116] !== t26 || $[117] !== t37) {
    t38 = <ListingLayout counter={counter} type="compact" title={t18} data={subAccounts} createData={t26}>{t37}</ListingLayout>;
    $[113] = counter;
    $[114] = subAccounts;
    $[115] = t18;
    $[116] = t26;
    $[117] = t37;
    $[118] = t38;
  } else {
    t38 = $[118];
  }
  return t38;
}
function _temp(subAccount) {
  return <div className="flex items-center gap-2">{subAccount.profileImage && <img className="h-10 w-10 rounded-full object-cover" src={subAccount.profileImage.path} />}<div className="flex flex-col"><span>{subAccount.displayName}</span></div></div>;
}
export const getServerSideProps = getCombinedServerSideProps(getBaseServerSideProps(SubAccountsLoco, 'header.top_menu.sub_accounts'));
export default SubAccounts;